import Block from './Block'

export default class ProductTabs extends Block {
  onEnterCompleted() {
    super.onEnterCompleted()

    this.currentIndex = 0;
  }

  getElems() {
    super.getElems()

    this.$titles = this.el.querySelectorAll('.single-product__tabs-tab')
    this.$text = this.el.querySelectorAll('.single-product__tabs-item')
  }

  events() {
    super.events()

    for (let i = 0; i < this.$titles.length; i++) {
      this.$titles[i].addEventListener('click', this.toggle.bind(this, i))
    }
  }

  toggle(i) {
    if (i !== this.currentIndex) {
      this.$titles[this.currentIndex].classList.remove('active')
      this.$titles[i].classList.add('active')
      this.$text[this.currentIndex].classList.remove('active')
      this.$text[i].classList.add('active')
      this.currentIndex = i
    }
  }
}



// WEBPACK FOOTER //
// ./scripts/blocks/ProductTabs.js